import { Box, Flex } from "@chakra-ui/react";
import Sidebar from "./Sidebar";

const Layout = ({ children }) => {
  return (
    <Flex>
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content Area */}
      <Box flex="1" p={{ base: 0, md: 5 }} ml={{ base: 0, md: "218px" }}>
        {children}
      </Box>
    </Flex>
  );
};

export default Layout;
